(function () {
  if (window.__keweEnergyLinkCardsInitialized) return;
  window.__keweEnergyLinkCardsInitialized = true;

  const sectionSelector = '.kewe-energy-link-cards';

  function updateButtons(track, prevButton, nextButton) {
    if (!track || !prevButton || !nextButton) return;

    const maxScrollLeft = track.scrollWidth - track.clientWidth;
    prevButton.disabled = track.scrollLeft <= 4;
    nextButton.disabled = track.scrollLeft >= maxScrollLeft - 4;
  }

  function getScrollAmount(track) {
    const firstCard = track.querySelector('.kewe-energy-link-cards__card');
    if (!firstCard) return track.clientWidth * 0.8;

    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0');
    return firstCard.getBoundingClientRect().width + gap;
  }

  function attachDrag(track) {
    let pointerId = null;
    let startX = 0;
    let startScrollLeft = 0;
    let dragDistance = 0;
    let isDragging = false;

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      dragDistance = 0;
      isDragging = false;
    });

    track.addEventListener('pointermove', (event) => {
      if (pointerId !== event.pointerId) return;

      const deltaX = event.clientX - startX;
      dragDistance = Math.max(dragDistance, Math.abs(deltaX));

      if (dragDistance > 8) {
        if (!isDragging) {
          isDragging = true;
          track.classList.add('is-dragging');

          if (track.setPointerCapture) {
            track.setPointerCapture(pointerId);
          }
        }

        track.scrollLeft = startScrollLeft - deltaX;
      }
    });

    track.addEventListener('pointerup', (event) => {
      if (pointerId !== event.pointerId) return;

      if (isDragging) {
        track.dataset.kewePreventClick = 'true';

        window.setTimeout(() => {
          delete track.dataset.kewePreventClick;
        }, 0);
      }

      track.classList.remove('is-dragging');

      if (track.hasPointerCapture && track.hasPointerCapture(pointerId)) {
        track.releasePointerCapture(pointerId);
      }

      pointerId = null;
      isDragging = false;
    });

    track.addEventListener('pointercancel', (event) => {
      if (pointerId !== event.pointerId) return;

      track.classList.remove('is-dragging');

      if (track.hasPointerCapture && track.hasPointerCapture(pointerId)) {
        track.releasePointerCapture(pointerId);
      }

      pointerId = null;
      isDragging = false;
    });

    track.addEventListener('click', (event) => {
      if (track.dataset.kewePreventClick === 'true') {
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }

  function initSection(section) {
    if (!section || section.dataset.keweLinkCardsReady === 'true') return;

    const track = section.querySelector('[data-kewe-link-cards-track]');
    const prevButton = section.querySelector('[data-kewe-link-cards-prev]');
    const nextButton = section.querySelector('[data-kewe-link-cards-next]');

    if (!track || !prevButton || !nextButton) return;

    section.dataset.keweLinkCardsReady = 'true';

    prevButton.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollAmount(track), behavior: 'smooth' });
    });

    nextButton.addEventListener('click', () => {
      track.scrollBy({ left: getScrollAmount(track), behavior: 'smooth' });
    });

    track.addEventListener('scroll', () => updateButtons(track, prevButton, nextButton), { passive: true });
    window.addEventListener('resize', () => updateButtons(track, prevButton, nextButton));

    attachDrag(track);
    updateButtons(track, prevButton, nextButton);
  }

  function initAll(root) {
    (root || document).querySelectorAll(sectionSelector).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
